export default __webpack_public_path__ + "static/media/HairAndBeauty.a8db60d2.svg";